import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import UserProfileDashboard from './pages/user-profile-dashboard';
import MissionMapDashboard from './pages/mission-map-dashboard';
import MissionWorkspace from './pages/mission-workspace';
import UserRegistration from './pages/user-registration';
import MissionResultsSummary from './pages/mission-results-summary';
import Homepage from './pages/homepage';
import About from './pages/about';
import Roadmap from './pages/roadmap';
import TestingRoadmapsHub from './pages/testing-roadmaps-hub';
import TutorialLearningCenter from './pages/tutorial-learning-center';
import InterviewPreparationSuite from './pages/interview-preparation-suite';
import ComprehensiveInterviewSimulator from './pages/comprehensive-interview-simulator';
import RoadmapSelectionHub from './pages/roadmap-selection-hub';
import ChallengesArena from './pages/challenges-arena';
import Contact from './pages/contact';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        
        {/* Navigation sequence: Home → Roadmaps → Tutorials → Challenges → Interview Prep */}
        <Route path="/roadmap" element={<RoadmapSelectionHub />} />
        <Route path="/roadmaps" element={<RoadmapSelectionHub />} />
        <Route path="/learning-paths" element={<RoadmapSelectionHub />} />
        
        <Route path="/tutorial-learning-center" element={<TutorialLearningCenter />} />
        <Route path="/tutorial-learning-center/:tutorialSlug" element={<TutorialLearningCenter />} />
        <Route path="/tutorial-learning-center/:tutorialSlug/:lessonId" element={<TutorialLearningCenter />} />
        <Route path="/tutorials" element={<TutorialLearningCenter />} />
        
        <Route path="/challenges" element={<ChallengesArena />} />
        <Route path="/challenges-arena" element={<ChallengesArena />} />
        
        <Route path="/interview-preparation-suite" element={<InterviewPreparationSuite />} />
        <Route path="/interview-prep" element={<InterviewPreparationSuite />} />
        <Route path="/comprehensive-interview-simulator" element={<ComprehensiveInterviewSimulator />} />
        
        {/* Keep legacy routes for backward compatibility */}
        <Route path="/roadmap-selection-hub" element={<RoadmapSelectionHub />} />
        <Route path="/real-world-challenges-arena" element={<ChallengesArena />} />
        <Route path="/testing-roadmaps-hub" element={<TestingRoadmapsHub />} />
        
        {/* Development roadmap moved to a more specific path */}
        <Route path="/development-roadmap" element={<Roadmap />} />
        <Route path="/platform-roadmap" element={<Roadmap />} />
        
        {/* About page - accessible but not in main nav */}
        <Route path="/about" element={<About />} />
        
        <Route path="/contact" element={<Contact />} />
        
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/user-profile-dashboard" element={<UserProfileDashboard />} />
        <Route path="/mission-map-dashboard" element={<MissionMapDashboard />} />
        <Route path="/mission-workspace" element={<MissionWorkspace />} />
        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/mission-results-summary" element={<MissionResultsSummary />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;